<script lang="ts">
  import { onMount } from 'svelte';
  import {
    DataTable,
    DataTableRow,
    DataTableCell,
    DataTableHead,
    DataTableBody,
  } from 'svelte-materialify';
  import { fromNow } from '../../lib/date';
  import type { UserEvent } from '../../lib/pandalytics';
  import { queryUserEvents } from '../../lib/pandalytics';
  import { UserService } from '../../modules';

  import type { User } from '../../modules/user/user.interface';
  import UsePreviewItem from '../item/UsePreviewItem.svelte';
  import Page from '../Page.svelte';
  import Scroller from '../Scroller.svelte';

  export let params: { project: string; distinctId: string };

  let events: UserEvent[] = [];
  let page = 1;
  let limit = 50;
  let message = '';

  onMount(fetchEvents);

  async function fetchEvents() {
    const result = await queryUserEvents({
      project: params.project,
      distinctId: params.distinctId,
      page,
      limit,
    });

    if (!result.docs?.length) {
      message = 'No Events!';
      return;
    }

    message = '';
    events = result.docs;
  }

  function isItemAction(action: string) {
    return ['BOOKMARK_ADD', 'BOOKMARK_DELETE', 'ITEM_CLICK'].includes(action);
  }
</script>

{#if events.length}
  <Page title={params.distinctId}>
    <Scroller>
      {#if message}
        <h3>{message}</h3>
      {/if}
      {#if events.length}
        <DataTable>
          <DataTableHead>
            <DataTableRow>
              <DataTableCell>Event</DataTableCell>
              <DataTableCell>Category</DataTableCell>
              <DataTableCell>Label</DataTableCell>
              <DataTableCell numeric>Value</DataTableCell>
              <DataTableCell numeric>Date</DataTableCell>
            </DataTableRow>
          </DataTableHead>
          <DataTableBody>
            {#each events as event}
              <DataTableRow>
                <DataTableCell>{event.action}</DataTableCell>
                <DataTableCell>{event.category || ''}</DataTableCell>
                <DataTableCell>
                  {#if isItemAction(event.action)}
                    <UsePreviewItem
                      id={event.label}
                      project={params.project}
                      category={event.category}>{event.label}</UsePreviewItem
                    >
                  {:else}
                    {event.label || ''}
                  {/if}
                </DataTableCell>
                <DataTableCell numeric>{event.value || ''}</DataTableCell>
                <DataTableCell numeric>
                  <span title={event.createdAt}>
                    {fromNow(event.createdAt)}
                  </span>
                </DataTableCell>
              </DataTableRow>
            {/each}
          </DataTableBody>
        </DataTable>
      {/if}
    </Scroller>
  </Page>
{/if}
